<template lang="pug">
    .component-smart-edit.card
        .inner-content
            .field(v-for="(item, index) in mutableItem")
                smart-edit-field(v-model="mutableItem[index]", :name="index", :options="options")

</template>
<script type="text/babel">
    import SmartEditField from "./SmartEditField";
    export default{
        components: {SmartEditField},
        name: "SmartEdit",
        data(){
            return {
                mutableItem: this.value
            }
        },
        watch: {
            mutableItem: function (newValue, oldValue) {
                this.$emit('input', newValue)
            },
            value: function (newValue, oldValue) {
                if (JSON.stringify(newValue) !== JSON.stringify(this.mutableItem)) {
                    this.mutableItem = newValue
                }
            }
        },
        props: [
            'value',
            'options'
        ],
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// SmartEdit.vue?18e05c50